import {MetaTagsProps, SubCategory} from "@/types";
import {content} from "./content";
import {images} from "./images";
import {BUSINESS_NAME, OG_PATH} from "@/content";

const serviceId = 4
const slug = 'switchboard-repairs-and-modernisation-sydney';
export const createMetaTags = (parentMetaTags: MetaTagsProps): { metaTags: MetaTagsProps; slug: string } => {

    const metaTags : MetaTagsProps =  {
        title: `Switchboard Repairs & Modernisation Sydney | ${BUSINESS_NAME}`,
        description: "Upgrade old or faulty switchboards with safer, compliant, and more efficient technology.",
        keywords: "switchboard repairs Sydney, switchboard modernisation, electrical switchboard upgrade, faulty switchboard replacement, circuit breaker installation, switchboard safety compliance, residential switchboard services, commercial switchboard solutions, electrical panel upgrade, licensed electricians Sydney",
        url: `${parentMetaTags.url}/${slug}`,
        ogImage: `${OG_PATH}c1-s${serviceId}.jpg`,
        type: "website",
    };

    return {metaTags, slug};
};

export const category: Omit<SubCategory, 'headCategory' | 'slug' | 'metaTags'> = {
    id: serviceId,
    title: 'Switchboard Repairs & Modernisation',
    description: "Upgrade old or faulty switchboards with safer, compliant, and more efficient technology.",
    points: [

    ],
    images: images.map((image, index) => ({
        ...image,
        alt: `${slug}-${index + 1}`,
    })),
    content,
}
